import { render, staticRenderFns } from "./RoleAvatar.vue?vue&type=template&id=c935fbf2&scoped=true"
import script from "./RoleAvatar.vue?vue&type=script&lang=js"
export * from "./RoleAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c935fbf2",
  null
  
)

export default component.exports